import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function Connected() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const accountId = searchParams.get('account');

  useEffect(() => {
    // Store the account info and redirect after a delay
    if (accountId) {
      // Generate a simple user ID from account ID for now
      // In production, this would come from your auth system
      localStorage.setItem('docusign_user_id', accountId);

      const timer = setTimeout(() => {
        navigate('/');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [accountId, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]">
      <div className="bg-white shadow rounded-lg p-8 text-center max-w-md">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
          <svg
            className="h-8 w-8 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Successfully Connected!</h2>
        <p className="text-gray-600 mb-4">
          Your DocuSign account has been connected to IntegraLedger.
        </p>
        {accountId && (
          <p className="text-sm text-gray-500 mb-4">Account ID: {accountId}</p>
        )}
        <p className="text-sm text-gray-400">Redirecting to dashboard...</p>
      </div>
    </div>
  );
}
